import { render, staticRenderFns } from "./SupportWidgetModal.vue?vue&type=template&id=609cf572&scoped=true&"
import script from "./SupportWidgetModal.vue?vue&type=script&lang=ts&"
export * from "./SupportWidgetModal.vue?vue&type=script&lang=ts&"
import style0 from "./SupportWidgetModal.vue?vue&type=style&index=0&id=609cf572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609cf572",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VContainer,VIcon,VMenu})
